module.exports = __webpack_public_path__ + "base-c3a15aec68bde686b6fa7b42e99fcdc6.svg";